export default __webpack_public_path__ + "static/media/gallery28.744cbb4b.webp";